import { Message } from "../entities/app-entities/Message";
import { EventBus } from "./event-bus";
export default {
  manageError(context, error) {
    var message = null;
    switch (error.status) {
      case 0:
        message = new Message(
          context.$t("error.server_unavailable"),
          6000,
          "error"
        );
        break;
      case 400:
        context.formErrors = {};
        error.body.forEach((error) => {
          context.formErrors[error.key] = context.$t(
            "error.bad_request." + error.error
          );
        });
        break;
      case 403:
        const forbiddenErrorMessages = {
          INVALID_CREDENTIALS: context.$t("error.forbidden"),
          INVALID_EXTERNAL_TOKEN: context.$t("error.invalid_token")
        };

        if(error.body.error == 'INVALID_EXTERNAL_TOKEN') {
          message = new Message(
            context.$t("error.conflict." + error.body.error),
            6000,
            "error"
          );
        }
        
        context.formErrors = {
          login: forbiddenErrorMessages[error.body.error] || context.$t("error.forbidden"),
        };
        break;
      case 401:
        context.auth.logout(context);
        break;
      case 409:
        message = new Message(
          context.$t("error.conflict." + error.body.error),
          6000,
          "error"
        );
        break;
      case 500:
        message = new Message(context.$t("error.server_error"), 6000, "error");
        break;
      case 502:
        context.auth.logout(context);
        break;
    }
    if (message) {
      EventBus.$emit("showMessage", message);
    }
  },
};
